import { RouteBuilders, RouteUpdaters } from '../../../Shared/Frontend/utils/routes.shared'
import { application, ApplicationPages } from '../allIncludedModules'
import { State } from '../root/root.state'

export type Pages = ApplicationPages

let _application = application ? application as any : {} as any

export const routeBuilders: RouteBuilders<State, Pages> = {
  ...(application ? _application.routeBuilders() as any : {} as any)
}

export const routeUpdaters: RouteUpdaters<State, Pages> = {
  ...(application ? _application.routeUpdaters() as any : {} as any)
}
